'use strict';

var d3 = require('d3');
var AnalysisChart = function AnalysisChart(AbstractChart, SeasonalityConstants, chartMultiBrush, chartGroups, chartXAxis, chartYAxis, chartStripes, chartSimpleBars, chartConstants, chartHorizontalAverageLines, seasonalityConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters, seasonalityType) {
    var self = this;
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var brush = chartMultiBrush();
    var bars = chartSimpleBars('m1');
    var groups, horizontalAverageLines;
    if (seasonalityType === seasonalityConstants.SEASONALITY_TYPE.POOLED) {
      groups = chartGroups('d1', formatters.tooltipFormatter, true);
    } else {
      groups = chartGroups('d1', undefined, true);
      horizontalAverageLines = chartHorizontalAverageLines('season', formatters.tooltipFormatter);
    }
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withTextRotation(chartConstants.AXIS.SKEW.DEG_30);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withoutHorizontalLines();
    this.render = function (data, range) {
      range = range || [0, data.length];
      this.initChart(data, range, chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      if (horizontalAverageLines) {
        this.callForDataGroup([yAxisLeft, groups, bars, horizontalAverageLines, xAxis], this.scales);
      } else {
        this.callForDataGroup([yAxisLeft, groups, bars, xAxis], this.scales);
      }
    };
    this.getSelectedBars = function () {
      var selectedBarsNumbers = brush.getSelection();
      var selectedBars = [];
      for (var i in selectedBarsNumbers) {
        selectedBars[i] = [];
        if (selectedBarsNumbers[i]) {
          for (var j = selectedBarsNumbers[i][0], last = selectedBarsNumbers[i][1]; j < last; j++) {
            selectedBars[i].push(this.data[j]);
          }
        }
      }
      return selectedBars;
    };
    this.getSelection = function () {
      return brush.getSelection();
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.setInitialSelection = function (range) {
      brush.setSelection(range);
    };
    this.withMetric = function (metric) {
      yAxisLeft.label(metric);
      return this;
    };
    brush.on('brushchange', function (ranges) {
      self.brushChangeAction(ranges, groups);
      dispatch.rangechange(ranges);
    });
    groups.on('groupclick', function (d, i) {
      brush.setSelection([i, i + 1]);
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
AnalysisChart.$inject = ['AbstractChart', 'SeasonalityConstants', 'ChartElementsMultiBrush', 'ChartElementsGroup', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsStripes', 'ChartElementsSimpleBars', 'ChartElementsConstants', 'ChartElementsHorizontalAverageLines', 'SeasonalityConstants'];
module.exports = AnalysisChart;